import { render, staticRenderFns } from "./MotivoNaoVendaManage.vue?vue&type=template&id=66bfa6f2&scoped=true"
import script from "./MotivoNaoVendaManage.vue?vue&type=script&lang=js"
export * from "./MotivoNaoVendaManage.vue?vue&type=script&lang=js"
import style0 from "./MotivoNaoVendaManage.vue?vue&type=style&index=0&id=66bfa6f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bfa6f2",
  null
  
)

export default component.exports